import styled from "styled-components";

export const PrarentDialogDiv = styled.div`
  & .css-1e6y48t-MuiButtonBase-root-MuiButton-root {
    text-transform: none;
    background-color: green;
    color: white;
    border-radius: 25px;
    padding: 1px 15px;
    margin-top: 10px;
    font-size: 0.9rem;

    :hover {
      color: rgb(2, 236, 136);
      background-color: green;
    }
  }
`;

export const Ptag = styled.p`
  text-align: justify;
`;
